export const productTypeSelect = {
	label: "Product type",
	placeholder: "Select type",
	loading: "Loading...",
};
